<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container plan-page">
        <!-- Stripe -->
        <div v-if="profile.subscription_id">
          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="tab" style="background: #7fcfd333; border-bottom: 0">
                <h1>Plano Starter</h1>
                <a
                  class="btn btn-small"
                  @click="manageStripeSubscription()"
                  v-if="profile.subscription_id && profile.plan === 'Starter'"
                  ><i class="fa fa-gear" style="padding-right: 5px"></i> Gerenciar</a
                >
                <a class="btn btn-small" style="visibility: hidden" v-else>.</a>
              </div>

              <div class="description-part section plan" style="background: #7fcfd333">
                <div style="padding-top: 0.2rem">
                  <strong class="price">R$ 49,90/mês</strong>
                  <em class="current-plan" v-if="profile.plan === 'Starter'">
                    (seu plano)</em
                  >
                  <em class="current-plan" v-else style="visibility: hidden">.</em>
                  <ul class="mt-4">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Curso de
                      Introdução à AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Prioridade
                      na aprovação de propostas
                    </li>
                    <!-- <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Mais destaque e visibilidade nas propostas
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Formação
                      Completa em AV
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Mentorias
                      em grupo
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="tab" style="background: #e4daf3; border-bottom: 0">
                <h1>Virtap Club</h1>
                <a
                  class="btn btn-small disabled"
                  @click="subscribe('VirtapClub')"
                  v-if="profile.status === 1"
                  disabled
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('VirtapClub')"
                  v-else-if="
                    profile.plan === 'Free' &&
                    profile.latest_paid_subscription &&
                    profile.active_subscription === null &&
                    profile.latest_paid_subscription.plan === 'VirtapClub'
                  "
                  ><i class="fa fa-refresh" style="padding-right: 5px"></i> Renovar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('VirtapClub')"
                  v-else-if="profile.plan !== 'VirtapClub'"
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
              </div>

              <div class="description-part section plan" style="background: #e4daf3">
                <div style="padding-top: 0.2rem">
                  <strong class="price"
                    >12x de R$ 149,90/mês
                    <!-- <span style="color: #f64b2f"> (22% OFF)</span> -->
                    <!-- <s style="font-size: 80%; color: #f64b2f">
                      12x de R$ 89,90/mês
                    </s> -->
                  </strong>
                  <em class="current-plan" v-if="profile.plan === 'VirtapClub'">
                    (seu plano)</em
                  >
                  <em class="current-plan" v-else style="visibility: hidden">.</em>
                  <ul class="mt-4">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Curso de
                      Introdução à AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Prioridade
                      na aprovação de propostas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Formação
                      Completa em AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Mentorias
                      em grupo
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Mais
                      destaque e visibilidade nas propostas
                    </li>

                    <a
                      class="btn btn-secondary btn-small mt-2"
                      :href="virtapClubPage"
                      target="_blank"
                      ><i class="fa fa-plus" /> Saiba mais</a
                    >
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Virtap -->
        <div v-else>
          <!-- Profile status -->
          <div class="alert alert-warning mb-0 under-review" v-if="profile.status == 1">
            <i class="fa-solid fa-circle-exclamation"></i> Seu perfil está sendo analisado
            pela nossa equipe.<br />
            Assim que for aprovado, você poderá assinar a Virtap e aproveitar todos os
            benefícios!
          </div>

          <!-- Status and offers -->
          <div v-else>
            <div
              class="alert alert-danger mb-0 under-review"
              v-if="profile.subscription && profile.subscription.expired"
            >
              <i class="fa-solid fa-circle-exclamation"></i>

              <span v-if="profile.subscription.plan === 'Trial'">
                Seu plano
                <strong>Starter</strong> de 30 dias terminou em
                <strong>{{ formatTimestamp(profile.subscription.end_timestamp) }}</strong
                >. Ative um plano e continue tendo acesso às oportunidades!</span
              >
              <span v-else>
                Seu plano
                <strong>{{ formatPlan(profile.subscription.plan) }}</strong>
                venceu em
                <strong>{{ formatTimestamp(profile.subscription.end_timestamp) }}</strong
                >. Ative um plano e continue tendo acesso às oportunidades!</span
              >
            </div>

            <div
              class="alert mb-0 under-review"
              :class="{
                'alert-warning': profile.subscription.plan === 'Trial',
                'alert-info': profile.subscription.plan !== 'Trial',
              }"
              v-else-if="profile.subscription && !profile.subscription.expired"
            >
              <i
                class="fa"
                :class="{
                  'fa-unlock': profile.subscription.plan === 'Trial',
                  'fa-rotate': renewablePlan,
                  'fa-calendar-check': !renewablePlan,
                }"
              ></i>
              <span
                v-if="
                  profile.subscription.plan === 'Trial' &&
                  profile.monthlyProposals.current < profile.monthlyProposals.limit
                "
              >
                Seu acesso de 30 dias está ativo e termina em

                <strong>{{ formatTimestamp(profile.subscription.end_timestamp) }}</strong
                >. Você ainda pode enviar
                <strong>{{
                  formatPlural(
                    profile.monthlyProposals.limit - profile.monthlyProposals.current,
                    "proposta",
                    "propostas"
                  )
                }}</strong>
                até essa data.</span
              >
              <span
                v-else-if="
                  profile.subscription.plan === 'Trial' &&
                  profile.monthlyProposals.current >= profile.monthlyProposals.limit
                "
              >
                Você já utilizou seu limite de
                <strong>{{ profile.monthlyProposals.limit }} propostas</strong> durante
                seu período de teste. Para enviar mais propostas, faça o upgrade do seu
                plano.</span
              >
              <span v-else>
                Você está assinando o plano
                <strong>{{ formatPlan(profile.subscription.plan) }}</strong
                >. Seu plano {{ renewablePlan ? "renova" : "vence" }} em
                <strong>{{ formatTimestamp(profile.subscription.end_timestamp) }}</strong
                >.</span
              >
            </div>

            <div
              class="alert mt-3 mb-0 under-review alert-warning"
              v-if="
                profile.subscription &&
                !profile.subscription.expired &&
                profile.subscription.plan === 'Professional'
              "
            >
              <i class="fa fa-calendar-check"></i>
              <span
                v-if="profile.monthlyProposals.current < profile.monthlyProposals.limit"
              >
                Você ainda pode enviar
                <strong>{{
                  formatPlural(
                    profile.monthlyProposals.limit - profile.monthlyProposals.current,
                    "proposta",
                    "propostas"
                  )
                }}</strong>
                antes da renovação do seu limite em
                <strong>{{
                  formatTimestamp(profile.monthlyProposals.end_timestamp)
                }}</strong
                >.</span
              >
              <span v-else>
                Você já utilizou seu limite de
                <strong>{{ profile.monthlyProposals.limit }}</strong> propostas no ciclo
                atual. Novas propostas serão liberadas em
                <strong>{{
                  formatTimestamp(profile.monthlyProposals.end_timestamp)
                }}</strong
                >.
              </span>
            </div>

            <div
              class="alert alert-warning mb-3 text-center"
              v-else-if="profile.starterKitAvailable"
            >
              <span>
                <strong
                  style="margin-left: 0.5rem; font-size: 18px; display: block"
                  class="mb-2"
                  >OFERTA PROMOCIONAL PARA NOVOS MEMBROS</strong
                >
               Envie
                até 15 propostas para oportunidades de trabalho em seus primeiros 30 dias.<br />
                <p class="mt-2">
                  <strong class="fs-4 text-center">12x de R$ 9,90</strong>
                  <br />
                  (ou R$ 97,00 à vista)
                </p>
              </span>
              <div class="admin-buttons-h mt-3">
                <a class="btn" :href="starterKitPage"
                  ><i class="fa fa-unlock" /> Liberar meu acesso</a
                >
              </div>
            </div>
          </div>

          <!-- Plan table -->
          <div class="row gy-4 mt-0" v-if="profile.plan !== 'VirtapClub'">
            <div class="col-lg-6">
              <div class="tab" style="background: #7fcfd333; border-bottom: 0">
                <h1 class="text-primary fs-4">
                  Profissional
                  <em
                    class="current-plan fw-bold"
                    style="vertical-align: super"
                    v-if="profile.plan === 'Professional'"
                  >
                    (seu plano atual)</em
                  >
                </h1>
                <a
                  class="btn btn-small disabled"
                  @click="subscribe('Professional')"
                  v-if="profile.status === 1"
                  disabled
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('Professional')"
                  v-else-if="
                    profile.subscription &&
                    profile.subscription.expired &&
                    profile.subscription.plan === 'Professional'
                  "
                  ><i class="fa fa-refresh" style="padding-right: 5px"></i> Renovar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('Professional')"
                  v-else-if="profile.plan !== 'Professional' && profile.plan !== 'Elite'"
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
                <a v-else class="btn btn-small" style="visibility: hidden">.</a>
              </div>
              <div class="description-part section plan" style="background: #7fcfd333">
                <div style="padding-top: 0.2rem">
                  <div class="text-center mt-2">
                    <strong class="fs-4">12x de R$ 39,90</strong>
                    <p class="text-center mt-3 text-muted">(ou R$ 397,00 à vista)</p>
                  </div>
                  <div class="access-tri pro">
                    <i class="fa fa-calendar" /> Acesso por 3 meses
                  </div>
                  <ul class="mt-3">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Até 15
                      propostas de trabalho por mês
                    </li>

                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Acesso a
                      oportunidades Premium
                    </li>
                    <li>
                      <i class="fas fa-times-circle" style="color: #f64b2f"></i>Mais
                      destaque nas propostas
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="tab" style="background: #e4daf3; border-bottom: 0">
                <h1 class="text-primary fs-4">
                  Elite
                  <em
                    class="current-plan fw-bold"
                    style="vertical-align: super"
                    v-if="profile.plan === 'Elite'"
                  >
                    (seu plano atual)</em
                  >
                </h1>
                <a
                  class="btn btn-small disabled"
                  @click="subscribe('Elite')"
                  v-if="profile.status === 1"
                  disabled
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('Elite')"
                  v-else-if="
                    profile.subscription &&
                    profile.subscription.expired &&
                    profile.subscription.plan === 'Elite'
                  "
                  ><i class="fa fa-refresh" style="padding-right: 5px"></i> Renovar</a
                >
                <a
                  class="btn btn-small"
                  @click="subscribe('Elite')"
                  v-else-if="profile.plan !== 'Elite'"
                  ><i class="fa fa-cart-shopping" style="padding-right: 5px"></i>
                  Assinar</a
                >
              </div>

              <div class="description-part section plan" style="background: #e4daf3">
                <div style="padding-top: 0.2rem">
                  <div class="text-center mt-2">
                    <strong class="fs-4">12x de R$ 59,90</strong>
                    <p class="text-center mt-3 text-muted">(ou R$ 597,00 à vista)</p>
                  </div>
                  <div class="access-tri elite">
                    <i class="fa fa-calendar" /> Acesso por 3 meses
                  </div>
                  <ul class="mt-3">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Propostas
                      de trabalho ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Acesso a
                      oportunidades Premium
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Mais
                      destaque nas propostas
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Virtap Club -->
          <div class="row gy-4 mt-0" v-if="profile.plan === 'VirtapClub'">
            <div class="col-lg-12">
              <div class="tab" style="background: #e4daf3; border-bottom: 0">
                <h1>Você tem acesso a:</h1>
              </div>

              <div class="description-part section plan" style="background: #e4daf3">
                <div style="padding-top: 0">
                  <ul class="mt-0">
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Curso de
                      Introdução à AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Comunidade
                      Virtap
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Vídeo
                      aulas exclusivas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Propostas
                      ilimitadas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Prioridade
                      na aprovação de propostas
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Formação
                      Completa em AV
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Mentorias
                      em grupo
                    </li>
                    <li>
                      <i class="fas fa-check-circle" style="color: #6ab04c"></i>Mais
                      destaque e visibilidade nas propostas
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Billing details -->
          <div class="row gy-4 mt-2" v-if="profile.billing_details">
            <div class="col-12">
              <div class="tab">
                <h1>Seus dados para nota fiscal</h1>
                <div>
                  <a class="btn btn-small" @click="editBillingDetails()"
                    ><i class="fa fa-pencil" style="padding-right: 5px"></i> Editar</a
                  >
                </div>
              </div>
              <div class="section">
                <div>
                  <p><strong>Nome:</strong> {{ profile.billing_details.name }}</p>
                  <p>
                    <strong>CPF/CNPJ:</strong>
                    {{ formatCPFCNPJ(profile.billing_details.cpf_cnpj) }}
                  </p>
                  <!-- <p class="mt-3" v-if="profile.billing_details.address">
                    <strong>Endereço:</strong>
                    {{
                      formatAddress(
                        profile.billing_details.address,
                        profile.billing_details.address_number,
                        profile.billing_details.complement,
                        profile.billing_details.neighborhood
                      )
                    }}
                  </p>
                  <p v-if="profile.billing_details.zipcode">
                    <strong>CEP:</strong>
                    {{ formatZipCode(profile.billing_details.zipcode) }}
                  </p>
                  <p v-if="profile.billing_details.state">
                    <strong>Cidade:</strong>
                    {{
                      formatCity(
                        profile.billing_details.state,
                        profile.billing_details.city
                      )
                    }}
                    -
                    {{ profile.billing_details.state }}
                  </p>
                  <p class="mt-3" v-if="profile.billing_details.phone">
                    <strong>Telefone:</strong
                    >{{ formatPhone(profile.billing_details.phone) }}
                  </p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import FileUtils from "../../../js/utils/file.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "PlanPage");
    this.$store.commit("setActiveProjectList", null);
    this.loadClientProfile();
  },

  data() {
    return {
      profile: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    utmParams() {
      return "utm_source=plataforma&utm_medium=assistentes&utm_campaign=assinatura&utm_content=planos";
    },
    next() {
      return `plano`;
    },
    virtapClubPage() {
      return Config.virtapClubPage + `?${this.utmParams}&next=${this.next}`;
    },
    starterKitPage() {
      return (
        Config.purchasePage + `?p=VIRTAP_STARTER_KIT&${this.utmParams}&next=${this.next}`
      );
    },
    renewablePlan() {
      return false;
      // return (
      //   this.profile &&
      //   (this.profile.plan === "Professional" || this.profile.plan === "Elite")
      // );
    },
  },

  methods: {
    async loadClientProfile() {
      this.$store.commit("setLoading", true);
      try {
        this.profile = await AssistantManager.getPlan();
        if (this.profile.open_offer) {
          this.showOfferModal(this.profile.open_offer);
        }

        this.$store.commit("setActiveUser", this.profile);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.handleAPIError(error, "plano");
      }
    },
    formatPlan(plan) {
      if (plan === "VirtapClub") {
        return "Virtap Club";
      } else if (plan === "Trial") {
        return "Experimental";
      } else {
        return plan;
      }
    },

    editBillingDetails() {
      let $ctx = this;
      let $modal = $("#editBillingDetailsModal");

      let $cpf_cnpj = $modal.find("[data-cpf-cnpj]");
      let $name = $modal.find("[data-name]");
      // let $address = $modal.find("[data-address]");
      // let $number = $modal.find("[data-number]");
      // let $complement = $modal.find("[data-complement]");
      // let $neighborhood = $modal.find("[data-neighborhood]");
      // let $cep = $modal.find("[data-cep]");
      // let $city = $modal.find("[data-city]");
      // let $uf = $modal.find("[data-uf]");
      // let $phone = $modal.find("[data-phone]");

      $cpf_cnpj
        .data("get-field", function () {
          if (!$ctx.validateCPFCNPJ($cpf_cnpj.val().trim())) {
            $cpf_cnpj.closest(".item").addClass("error");
            return undefined;
          } else {
            $cpf_cnpj.closest(".item").removeClass("error");
            let val = $ctx.formatCPFCNPJ($cpf_cnpj.val().trim().replace(/\D/g, ""));
            $cpf_cnpj.val(val);
            return val.replace(/\D/g, "");
          }
        })
        .val($ctx.formatCPFCNPJ($ctx.profile.billing_details.cpf_cnpj));

      $name
        .data("get-field", function () {
          if (!$ctx.validateName($name.val().trim())) {
            $name.closest(".item").addClass("error");
            return undefined;
          } else {
            $name.closest(".item").removeClass("error");
            return $name.val().trim();
          }
        })
        .val($ctx.profile.billing_details.name);

      // $address
      //   .data("get-field", function () {
      //     if (!$ctx.validateAddress($address.val().trim())) {
      //       $address.closest(".item").addClass("error");
      //       return undefined;
      //     } else {
      //       $address.closest(".item").removeClass("error");
      //       return $address.val().trim();
      //     }
      //   })
      //   .val($ctx.profile.billing_details.address);

      // $number
      //   .data("get-field", function () {
      //     if (!$ctx.validateAddressNumber($number.val().trim())) {
      //       $number.closest(".item").addClass("error");
      //       return undefined;
      //     } else {
      //       $number.closest(".item").removeClass("error");
      //       return $number.val().trim();
      //     }
      //   })
      //   .val($ctx.profile.billing_details.address_number);

      // $complement
      //   .data("get-field", function () {
      //     return $complement.val().trim();
      //   })
      //   .val($ctx.profile.billing_details.complement);

      // $neighborhood
      //   .data("get-field", function () {
      //     if (!$ctx.validateNeighborhood($neighborhood.val().trim())) {
      //       $neighborhood.closest(".item").addClass("error");
      //       return undefined;
      //     } else {
      //       $neighborhood.closest(".item").removeClass("error");
      //       return $neighborhood.val().trim();
      //     }
      //   })
      //   .val($ctx.profile.billing_details.neighborhood);

      // $cep
      //   .data("get-field", function () {
      //     if (!$ctx.validateCEP($cep.val().trim())) {
      //       $cep.closest(".item").addClass("error");
      //       return undefined;
      //     } else {
      //       $cep.closest(".item").removeClass("error");
      //       let val = $ctx.formatZipCode($cep.val().trim().replace(/\D/g, ""));
      //       $cep.val(val);
      //       return val.replace(/\D/g, "");
      //     }
      //   })
      //   .val($ctx.profile.billing_details.zipcode);

      // $uf
      //   .data("get-field", function () {
      //     return $uf.val();
      //   })
      //   .val($ctx.profile.billing_details.state);

      // $ctx.populateMunicipios($ctx.profile.billing_details.state, $city);
      // $city
      //   .data("get-field", function () {
      //     return $city.val();
      //   })
      //   .val($ctx.profile.billing_details.city);

      // if (!$phone.data("get-field")) {
      //   let intl = window.intlTelInput($phone[0], {
      //     autoInsertDialCode: true,
      //     initialCountry: "BR",
      //     separateDialCode: true,
      //   });

      //   $phone.data("intl", intl);

      //   $phone.data("get-field", function () {
      //     if (!intl.isValidNumber()) {
      //       $phone.closest(".item").addClass("error");
      //       return undefined;
      //     } else {
      //       $phone.closest(".item").removeClass("error");
      //       intl.setNumber($phone.val());
      //       return intl.getNumber();
      //     }
      //   });
      // }
      // if ($ctx.profile.billing_details.phone) {
      //   $phone.data("intl").setNumber($ctx.profile.billing_details.phone);
      // }
      // $uf.off().on("change", function () {
      //   const ufSelecionado = $(this).val(); // Pega a UF selecionada
      //   $ctx.populateMunicipios(ufSelecionado, $modal.find("[data-city]")); // Chama a função para popular os municípios
      // });

      function validate(item) {
        let func = $(item).data("get-field");
        if (func) {
          func();
        } else {
          $(item).closest(".item").addClass("error");
        }
      }

      $modal.find(".item").removeClass("error");
      $modal.find("input").each((i, item) => {
        validate(item);
        $(item)
          .off()
          .on("blur", () => {
            validate(item);
          });
      });

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");
        $modal.find("input").each((i, item) => {
          if ($(item).data("get-field")() === undefined) {
            hasError = true;
          }
        });

        if (hasError) {
          return;
        }

        let billingDetails = {
          name: $name.val().trim(),
          cpf_cnpj: $cpf_cnpj.val().trim().replace(/\D/g, ""),
          // address: $address.val().trim(),
          // address_number: $number.val().trim(),
          // complement: $complement.val().trim(),
          // neighborhood: $neighborhood.val().trim(),
          // zipcode: $cep.val().trim().replace(/\D/g, ""),
          // city: $city.val().trim(),
          // state: $uf.val().trim(),
        };

        // billingDetails.phone = $phone.data("intl").getNumber();

        let result = await AssistantManager.updateBillingDetails(billingDetails);

        if (result.billingDetails) {
          $ctx.profile.billing_details = result.billingDetails;
        } else {
          throw new Error("Falha ao atualizar dados para nota fiscal.");
        }

        return true;
      };

      this.showModal(
        $modal,
        function () {
          $modal.find("[data-cpf-cnpj]").focus();
        },
        "Salvar",
        action,
        "Dados atualizados.",
        "Ocorreu um erro editar os dados para nota fiscal.\nPor favor, tente novamente."
      );
    },
    subscribe(plan) {
      if (this.profile.status === 1) {
        this.showError(
          "Seu perfil ainda está sendo analisado.\n\nAssim que for aprovado, você poderá assinar este plano."
        );

        return false;
      }

      if (plan.toUpperCase() === "VIRTAPCLUB") {
        plan = "VIRTAP_CLUB";
      } else if (plan.toUpperCase() === "VIRTAP_STARTER_KIT") {
        plan = plan.toUpperCase();
      } else {
        plan = `ASSINATURA_${plan.toUpperCase()}_TRI`;
      }
      location.href =
        Config.purchasePage + `?p=${plan}&${this.utmParams}&next=${this.next}`;
    },

    manageStripeSubscription() {
      window.open(Config.apiHost + "/assistant/manage-subscription");
    },
  },
};
</script>
